import React, { useEffect, useState } from 'react';
import { Typography, Empty } from 'antd';
import { getBotHistoryByPersonalNumber } from '../../../../services/kollectaHealthCore';
import { format, subYears } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import styles from './style.module.css';
import HealthCustomCard from '../../../../Components/HealthCustomCard/index.js';
import { usePatient } from '../../../../Contexts/PatientContext';
import { useLocation } from 'react-router-dom';

const { Text } = Typography;

const BotHistoryCard = () => {
  const { patientData } = usePatient();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  const personalNumber = patientData?.customer?.personalNumber;

  const configItems = [
    {
      label: 'Data',
      fieldKey: 'createdAt',
      type: 'date'
    },
    {
      label: 'Pergunta',
      fieldKey: 'question',
      type: 'text'
    },
    {
      label: 'Resposta',
      fieldKey: 'answer',
      type: 'text'
    }
  ];

  useEffect(() => {
    const fetchHistory = async () => {
      if (!personalNumber) {
        console.log('personalNumber não disponível, não fazendo requisição');
        setLoading(false);
        return;
      }

      try {
        console.log('Buscando histórico do bot para:', personalNumber);
        
        const endDate = new Date();
        const startDate = subYears(endDate, 1);
        
        const formattedStartDate = startDate.toISOString();
        const formattedEndDate = endDate.toISOString();
        
        console.log('Datas de busca:', { startDate: formattedStartDate, endDate: formattedEndDate });
        
        let botType = 'effects-adverse';
        if (pathname.startsWith('/dor')) botType = 'pain';
        else if (pathname.startsWith('/cirurgias')) botType = 'surgeries';
        const response = await getBotHistoryByPersonalNumber(
          personalNumber, 
          formattedStartDate, 
          formattedEndDate,
          botType
        );
        
        console.log('Resposta da API:', response);
        
        if (response.success) {
          const sortedHistory = response.data.sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
          );
          setHistory(sortedHistory);
        } else {
          setHistory([]);
        }
      } catch (error) {
        console.error('Erro ao carregar histórico do bot:', error);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [personalNumber]);

  const formatDate = (dateString) => {
    return format(new Date(dateString), 'dd-MM-yyyy', { locale: ptBR });
  };

  const renderFieldContent = (item, fieldKey) => {
    if (fieldKey === 'createdAt') {
      return formatDate(item[fieldKey]);
    }
    return item[fieldKey] || '-';
  };

  return (
    <div className={styles.wrapper}>
      <HealthCustomCard noPadding>
        <div className={styles.botHistoryCard}>
          {loading ? (
            <div className={styles.loadingContainer}>
              <Text>Carregando histórico...</Text>
            </div>
          ) : history.length > 0 ? (
            <>
              <div className={styles.detailCard}>
                {configItems.map((item, index) => (
                  <div key={index} className={styles.detailCardItem}>
                    <h1>{item.label}</h1>
                  </div>
                ))}
              </div>
              {history.map((item, index) => (
                <div key={item.id} className={styles.detailCard}>
                  {configItems.map((configItem, configIndex) => (
                    <div key={configIndex} className={styles.detailCardItem}>
                      <p>{renderFieldContent(item, configItem.fieldKey)}</p>
                    </div>
                  ))}
                </div>
              ))}
            </>
          ) : (
            <Empty description="Nenhum histórico de mensagens encontrado" />
          )}
        </div>
      </HealthCustomCard>
    </div>
  );
};

export default BotHistoryCard;
